import { styled } from "styled-components";
import { FloatingActionButton } from "../../ui/fab/fab.component";
import { SubmitButtonProps } from "./submit-button.props";
import { MdCheck } from "react-icons/md";
import { colors } from "../../../theme/colors";

export const SubmitButton = ({
  label,
  onClick,
  disabled,
  variant = "floating",
}: SubmitButtonProps) => {
  const Btn = variant === "inline" ? InlineButton : FloatingStyledButton;
  return (
    <Btn
      type="button"
      onClick={disabled ? () => null : onClick}
      $disabled={disabled}
    >
      <MdCheck /> {label}
    </Btn>
  );
};

const FloatingStyledButton = styled(FloatingActionButton)<{
  $disabled?: boolean;
}>`
  width: 20rem;
  left: 50%;
  transform: translateX(-50%);
  right: auto;
  z-index: 2;
  opacity: ${({ $disabled }) => ($disabled ? 0.7 : 1)};
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};

  & svg {
    transition: transform 0.3s;
  }

  &:hover {
    transform: translateX(-50%) translateY(-0.2rem);

    & svg {
      transform: rotate(10deg);
    }
  }
`;

const InlineButton = styled.button<{ $disabled?: boolean }>`
  position: relative;
  width: min(100%, 22rem);
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem 2.5rem;
  border: none;
  border-radius: 10rem;
  outline: none;
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};
  font-size: 1.6rem;
  font-weight: 600;
  color: ${colors.white.hex};
  background-image: linear-gradient(90deg, #438dc7 0%, #205496 100%);
  box-shadow: 2px 2px 40px 0 rgba(32, 84, 150, 0.32);
  opacity: ${({ $disabled }) => ($disabled ? 0.7 : 1)};
  transition: transform 0.3s, box-shadow 0.3s;

  & svg {
    flex-shrink: 0;
    transition: transform 0.3s;
  }

  &:hover:not(:disabled) {
    transform: translateY(-0.2rem);
    box-shadow: 2px 6px 44px 0 rgba(32, 84, 150, 0.38);

    & svg {
      transform: rotate(10deg);
    }
  }

  &:disabled {
    cursor: not-allowed;
  }

  @media only screen and (max-width: 48em) {
    font-size: 1.4rem;
    padding: 1.35rem 2rem;
  }
`;
